import { get, post, put } from './fetcher';

const C = '/api/admin/complex';

export const getSido = async (token) => {
  const r = await get(`${C}/sido`, {}, token);
  if (r?.success) return r.data || [];
  throw new Error(r?.message || '시도 조회 실패');
};
export const getSigungu = async (token, sido) => {
  const r = await get(`${C}/sigungu`, { sido }, token);
  if (r?.success) return r.data || [];
  throw new Error(r?.message || '시군구 조회 실패');
};
export const getDong = async (token, sigungu) => {
  const r = await get(`${C}/dong`, { sigungu }, token);
  if (r?.success) return r.data || [];
  throw new Error(r?.message || '읍면동 조회 실패');
};

// 조회 (페이징) → { items, total, page, pageSize }
export const queryDanji = async (token, { bjdCode, danjiName, rankerOnly, page = 1, pageSize = 30 }) => {
  const r = await get(`${C}/query`, { bjdCode, danjiName, rankerOnly: rankerOnly ? true : '', page, pageSize }, token);
  if (r?.success) {
    const d = r.data || {};
    return { items: d.items || [], total: d.total || 0, page: d.page || page, pageSize: d.pageSize || pageSize };
  }
  throw new Error(r?.message || '조회 실패');
};
export const assignRanker = async (token, danjiCodes) => {
  const r = await post(`${C}/assign-ranker`, { danjiCodes }, token);
  return { ok: !!r?.success, message: r?.message, count: r?.data?.count || 0 };
};
export const getDetail = async (token, danjiCode) => {
  const r = await get(`${C}/detail`, { danjiCode }, token);
  return { ok: !!r?.success, message: r?.message, detail: r?.data };
};
export const updateDanji = async (token, payload) => {
  const r = await put(`${C}/detail`, payload, token);
  return { ok: !!r?.success, message: r?.message };
};

// 동기화
export const syncSearch = async (token, { sido, sigungu, dong }) => {
  const r = await get(`${C}/sync-search`, { sido, sigungu, dong }, token);
  return { ok: !!r?.success, message: r?.message, rows: r?.data?.rows || [] };
};
export const loadRankerTargets = async (token, bjdCode) => {
  const r = await get(`${C}/ranker-targets`, { bjdCode }, token);
  return { ok: !!r?.success, message: r?.message, rows: r?.data?.rows || [] };
};
export const saveSync = async (token, { rows, asRanker }) => {
  const r = await post(`${C}/save`, { rows, asRanker }, token);
  return { ok: !!r?.success, message: r?.message, result: r?.data };
};
